<template>
  <v-container fluid>
    <v-dialog
      v-model="mainDialgo"
      scrollable
      :fullscreen="fullscreen"
      max-width="900px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ attrs }">
        <!-- v-on="on" -->
        <v-btn
          :class="fullscreen ? 'd-print-none' : ''"
          small
          color="success"
          v-bind="attrs"
          :loading="isloading"
          @click="OpenTranDialog"
          icon
        >
          <slot>
            <v-icon>fas fa-info-circle</v-icon>
          </slot>
        </v-btn>
      </template>
      <v-card>
        <v-card-title :class="titleColor">
          {{ Deptor.Name.toUpperCase() }} INVOICE
          <v-spacer></v-spacer>
          <v-btn class="d-print-none" dark text icon @click="close">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-card flat>
            <v-card-title>
              <v-spacer></v-spacer>

              <v-btn
                v-if="Transactions.length && fullscreen"
                icon
                class="d-print-none"
                @click="PrintPage"
                small
                color="success"
              >
                <v-icon>fas fa-print</v-icon>
              </v-btn>
            </v-card-title>

            <v-data-table :headers="headers" :items="Transactions">
              <template v-slot:top>
                <v-toolbar flat color="grey lighten-4">
                  <v-spacer></v-spacer>
                  <div>
                    <cashDisplay
                      :isloading="isloading"
                      :Balance="TotalDebt"
                    ></cashDisplay>
                  </div>
                </v-toolbar>
              </template>
              <!-- <template #item.date="{item}">
                {{ item }}
              </template> -->

              <template v-slot:[`item.Order`]="{ item }">
                {{ item.Order | filterCode }}
              </template>

              <template #[`item.DueAmount`]="{item}">
                {{ item.DueAmount.toLocaleString() }}
              </template>
              <template #[`item.Paid`]="{item}">
                <!-- {{ item.Paid.toLocaleString() }} -->
                {{
                  (
                    item.DueAmount -
                    item.Discount -
                    item.Balance
                  ).toLocaleString()
                }}
              </template>
              <template #[`item.Discount`]="{item}">
                {{ item.Discount.toLocaleString() }}
              </template>
              <template #[`item.Balance`]="{item}">
                {{ item.Balance.toLocaleString() }}
              </template>
            </v-data-table>
          </v-card>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
// import axios from "axios";
import { EventBus } from "@/main";
export default {
  components: { cashDisplay: () => import("@/components/util/displayCash") },
  props: {
    Deptor: { type: Object, required: true },
    BaseURL: { type: String, default: "/Reports/debtors/alldebts" },
    fullscreen: { type: Boolean, default: true },
  },
  data() {
    return {
      // BaseURL: "/supplier",
      mainDialgo: false,

      isloading: false,
      Transactions: [],
      EmptyMessage: "",
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        {
          text: "Order",
          align: "left",
          value: "Order",
        },
        { text: "Sale", value: "DueAmount" },
        { text: "Paid", value: "Paid" },
        { text: "Discount", value: "Discount" },
        { text: "Balance", value: "Balance" },
        // { text: "Ref", value: "Ref" }
      ],
    };
  },
  computed: {
    titleColor() {
      if (this.fullscreen) return "error white--text";
      return "teal white--text";
    },
    TotalDebt() {
      if (!this.Deptor) return [];
      else if (typeof this.Deptor.Amount === "object")
        return this.Deptor.Amount;
      return [
        {
          Amount: this.Deptor.Amount,
          AmountType: "KES",
        },
      ];
    },
  },
  methods: {
    async PrintPage() {
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
    },

    OpenTranDialog() {
      this.isloading = true;
      //   this.Transactions = [];
      //   console.log(this.Deptor);
      this.GetReq().then(val => {
        // console.log(val.data);
        this.mainDialgo = true;
        this.isloading = false;
        function predictor(arr) {
          try {
            return arr.reduce(
              (result, cost) => {
                // console.log(cost);
                // if (
                //   cost.AccountName == "Cash" ||
                //   cost.AccountName == "Mobel" ||
                //   cost.AccountName == "Main Bank"
                // )
                //   result.Paid = cost.Amount;
                if (cost.AccountName == "Sales")
                  result.DueAmount += cost.Amount;
                if (cost.AccountName == "Sales Receivable") {
                  result.Balance += cost.Amount;
                  // console.log(cost);
                }
                if (cost.AccountName == "Sales Discount")
                  result.Discount += cost.Amount;
                result.date = cost.date;
                return result;
              },
              {
                DueAmount: 0,
                Paid: 0,
                Discount: 0,
                Balance: 0,
              }
            );
          } catch (error) {
            console.log(error);
            this.isloading = false;
          }
        }
        this.Transactions = Object.keys(val.data).map(key => {
          //   const costs = predictor(val.data[key]);
          //   console.log(predictor(val.data[key]));
          const tran = {
            Order: key,
            ...predictor(val.data[key]),
          };
          return tran;
        });
        // console.log(this.Transactions);
      });
    },
    GetReq() {
      return this.$store.dispatch("FIND_BY_VALUE", {
        url: this.BaseURL,
        query: {
          Description: this.Deptor.Description,
          //   Account: this.Deptor.Account
        },
      });
    },

    close() {
      this.mainDialgo = false;
    },
  },
  created() {
    // this.LoadCustomerData();
  },
};
</script>
